<section class="material-comparison">
    <header class="comparison-header">
        <div class="comparison-primary-row">
            <div class="comparison-heading">
                <div class="comparison-title">Device Comparison</div>
                <div
                    class="comparison-tabs"
                    role="tablist"
                    aria-label="Comparison chart">
                    <button
                        type="button"
                        role="tab"
                        class="comparison-tab"
                        [class.active]="(activeView$ | async) === 'size-change'"
                        [attr.aria-selected]="(activeView$ | async) === 'size-change'"
                        (click)="selectView('size-change')">
                        Size Change %
                    </button>
                    <button
                        type="button"
                        role="tab"
                        class="comparison-tab"
                        [class.active]="(activeView$ | async) === 'size-over-time'"
                        [attr.aria-selected]="(activeView$ | async) === 'size-over-time'"
                        (click)="selectView('size-over-time')">
                        Size Range Over Time
                    </button>
                </div>
            </div>
        </div>

        <div class="comparison-secondary-row">
            <div class="device-legend">
                <button
                    type="button"
                    *ngFor="let device of devices; trackBy: trackByDeviceId"
                    class="device-chip"
                    [class.is-hidden]="(activeView$ | async) === 'size-over-time'
                        && !isDeviceVisible(device.id)"
                    [disabled]="(activeView$ | async) !== 'size-over-time'"
                    [attr.aria-pressed]="(activeView$ | async) !== 'size-over-time'
                        || isDeviceVisible(device.id)"
                    [attr.aria-label]="(activeView$ | async) === 'size-over-time'
                        ? (isDeviceVisible(device.id) ? 'Hide ' : 'Show ') + device.name
                        : device.name"
                    (click)="toggleDeviceVisibility(device.id)"
                    [style.--device-color]="getDeviceColor(device)">
                    <span class="device-dot"></span>
                    {{ device.name }}
                </button>
            </div>

            <div class="comparison-controls">
                <div
                    class="comparison-control"
                    *ngIf="(activeView$ | async) === 'size-over-time'">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Size</mat-label>
                        <mat-select [value]="range$ | async" (valueChange)="updateRange($event)">
                            <mat-option *ngFor="let range of sizeRanges" [value]="range.id">
                                {{ range.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <ng-container
                    *ngIf="(activeView$ | async) === 'size-over-time'
                        && (range$ | async) === 'custom'">
                    <div class="comparison-control custom-range-control">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Min (in)</mat-label>
                            <input
                                matInput
                                type="number"
                                min="0"
                                step="0.1"
                                [value]="customMinimum$ | async"
                                (input)="updateCustomMinimum($event)">
                        </mat-form-field>
                    </div>

                    <div class="comparison-control custom-range-control">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Max (in)</mat-label>
                            <input
                                matInput
                                type="number"
                                min="0"
                                step="0.1"
                                [value]="customMaximum$ | async"
                                (input)="updateCustomMaximum($event)">
                        </mat-form-field>
                    </div>

                    <button
                        type="button"
                        mat-flat-button
                        color="primary"
                        class="custom-range-fetch"
                        (click)="applyCustomRange()">
                        Fetch
                    </button>
                </ng-container>

                <div class="comparison-control">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Metric</mat-label>
                        <mat-select [value]="metric$ | async" (valueChange)="metric$.next($event)">
                            <mat-option value="count">Count</mat-option>
                            <mat-option value="volume">Volume</mat-option>
                            <mat-option value="mass">Estimated Mass</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </header>

    <div class="comparison-content chart-only">
        <div class="comparison-chart-pane">
            <ng-container *ngIf="activeChartState$ | async as state">
                <div *ngIf="state.loading" class="comparison-state">
                    <mat-spinner strokeWidth="3" [diameter]="36"></mat-spinner>
                </div>

                <highcharts-chart
                    *ngIf="!state.loading && state.hasData"
                    class="comparison-chart"
                    [Highcharts]="Highcharts"
                    [options]="state.options"
                    (chartInstance)="onChartInstance($event)">
                </highcharts-chart>

                <div *ngIf="!state.loading && !state.hasData" class="comparison-state comparison-message">
                    <mat-icon svgIcon="empty-data"></mat-icon>
                    <span>{{ state.message }}</span>
                </div>
            </ng-container>
        </div>

    </div>
</section>
